import * as is from 'utilities/is';
import { ANNOTATION_TARGETS } from 'constants';
import { listToTree, treeToList } from 'utilities/data';
import { LayoutFactory } from './layout_factory';

export class LayoutEngine {
    constructor({ layout = [] }) {
        this.regions = [];
        this.layout = layout;
        this.contentDimensions = {};
        this.playerAspect = null;
    }

    excludeEmpty(regions = [], layout = []) {
        const parents = layout.map(l => l.parent),
            isParent = l => parents.includes(l);

        const excluded = layout.reduce((b,l) => {
            if (isParent(l.name) || regions.includes(l.name)) {
                b.push(l);
            }

            return b;
        }, []);

        return excluded;
    }

    computeContentDimensions() {
        const 
            filtered = this.excludeEmpty(this.regions, this.layout),
            computed = this.computeLayout(filtered),
            root = computed.find(f => f.root),
            children = computed.filter(f => !f.root);

        if (!root) {
            return {};
        } 

        return {
            container: root.aspect,
            ...children.reduce((r,{ name, ...c}) => {
                r[name] = c;
                return r;
            }, {})   
        }
    }

    // "core" algorithm
    computeLayout(layout = []) {
        if (this.playerAspect) {
            layout = layout.map(l => l.name === ANNOTATION_TARGETS.PLAYER ? { ...l, aspect: this.playerAspect } : l)
        }

        const tree = listToTree(layout),
            sized = tree.map(LayoutFactory.create),
            flattened = sized.flatMap(s => treeToList(s, {}, this.serializeRegion));

        return flattened;
    }

    serializeRegion = (node, adjustments) => node.serialize(adjustments)

    set activeRegions(regions = []) {
        if (!is.equal(regions, this.regions)) {
            this.regions = regions;
            this.contentDimensions = this.computeContentDimensions();
        }
    }

    set activeLayout(layout = []) {
        if (!is.equal(layout, this.layout)) {
            this.layout = layout;
            this.contentDimensions = this.computeContentDimensions();
        }
    }

    set activePlayerAspect(aspect = null) {
        if (aspect && !isNaN(aspect)) {
            this.playerAspect = aspect;
            this.contentDimensions = this.computeContentDimensions();
        }
    }
}